import constants from '../../constants/constants'

export default {
    resizableSides: [constants.RESIZE_SIDES.TOP, constants.RESIZE_SIDES.BOTTOM],
    moveDirections: [constants.MOVE_DIRECTIONS.VERTICAL],
    fullWidth: true,
    mobileConversionConfig: {
        isScreenWidth: true,
        preserveAspectRatio: false
    }
}
